module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/pa-69b3b90501ccfc42beffe5f0fd531d4e.svg";